// Reuses the same Firebase project as the rest of PlayAware
// (gamingbuddy-fbc3a — prod, the single canonical project since the
// 2026-08-21 consolidation). Auth state, Showcase data, and pop-market
// data all share one Firestore so a seller's verified game account from
// Showcase shows up natively on their storefront.

import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Prod (gamingbuddy-fbc3a)
const firebaseConfig = {
  apiKey: "AIzaSyC0wo2PGNWo6RTFH2kt48-adsXtDzcoYQE",
  authDomain: "gamingbuddy-fbc3a.firebaseapp.com",
  projectId: "gamingbuddy-fbc3a",
  storageBucket: "gamingbuddy-fbc3a.firebasestorage.app",
  messagingSenderId: "949401280999",
  appId: "1:949401280999:web:24b2e93d528b3c161fdd42",
  measurementId: "G-QBMGHBFVLL",
};

const app = initializeApp(firebaseConfig);

// Firestore with the default in-memory cache. The persistent (IndexedDB)
// cache was pulled after it repeatedly stalled subscriptions and reads
// with pending-write / cross-tab-lock deadlocks. In-memory cache is
// still fast for same-page navigation; users pay one network round-trip
// per page load instead of nothing, which is an acceptable trade for
// consistently-working reads.
const db = getFirestore(app);

export { db };
export const auth = getAuth(app);
export const storage = getStorage(app);
// Same Google provider config used by playaware-content site. Shared
// project means a user signing in with Google here reuses the same
// app_users/{uid} record as on playaware.gg.
export const googleProvider = new GoogleAuthProvider();
// Pop-market callables live in asia-south1 (matches the existing automation
// codebase). spamCheck, badgeRender, tierEngine, etc.
export const functions = getFunctions(app, "asia-south1");

export default app;
